import { forwardRef, type SelectHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

// Styled native <select>. We intentionally avoid @radix-ui/react-select
// here: admin filters and category pickers are simple value-pickers and
// native <select> already gets accessibility, keyboard nav, and mobile
// virtual keyboards for free. shadcn's Select wrapper is reserved for
// future combobox / async-search cases.
export type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { className, ...props },
  ref
) {
  return (
    <select
      ref={ref}
      className={cn(
        "block w-full h-11 rounded-md border border-zinc-300 bg-brand-white px-3 text-base text-brand-black",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-red focus-visible:ring-offset-1",
        "disabled:pointer-events-none disabled:opacity-50",
        "aria-[invalid=true]:border-danger aria-[invalid=true]:focus-visible:ring-danger",
        className
      )}
      {...props}
    />
  );
});
